import { friendServer } from "@/http";

export default {
    async searchfriend(context, payload) {
        const response = await friendServer.get('/api/users', {
            params: {
                searchTerm: payload.searchTerm
            }
        });

        if (response.status !== 200) {
            const error = new Error(response.data.message || "Failed to search friend");
            throw error;
        }

        context.commit('setSearchFriend', response.data);

        return response.data;
    }
}
